import "./AboutHero.css";
import { useTranslation } from "../i18n";

function AboutHero() {
    const { t } = useTranslation();

    return (
        <div className="about-hero">
            <div className="overlay"></div>
            <div className="about-hero-container">
                {/* Primera columna: Contenido */}
                <div className="about-hero-content">
                    <h2>{t("about.heroKicker")}</h2>
                    <h1>Diego Sánchez Martín</h1>
                    <div className="underline"></div>
                    <p>{t("about.role")} </p>
                    <p>{t("about.expertise")}</p>
                </div>
            </div>
        </div>
    );
}

export default AboutHero;
